import { ButtonGroup as MuiButtonGroup, Button as MuiButton, styled } from '@mui/material'
import { alpha } from '@mui/material/styles'

export const ButtonGroup = styled(MuiButtonGroup)({
  backgroundColor: 'transparent',
})

export const Button = styled(MuiButton, {
  shouldForwardProp: prop => prop !== 'inverted',
})<{
  inverted?: boolean
}>(({ theme, inverted }) => ({
  minWidth: 0,
  color: inverted
    ? alpha(theme.palette.common.white, 0.75)
    : theme.icons?.toolbar || alpha(theme.palette.common.black, 0.54),
  borderColor: inverted ? alpha(theme.palette.common.black, 0.5) : 'transparent',
  border: inverted ? undefined : 0,
  borderRadius: inverted ? undefined : '50%',
  padding: theme.spacing(1),
  '&.MuiButton-sizeSmall': {
    width: theme.spacing(4),
    height: theme.spacing(4),
    padding: 0,
  },
  '& .MuiSvgIcon-root': {
    fontSize: 16,
  },

  '&:hover': {
    backgroundColor: inverted
      ? alpha(theme.palette.common.white, 0.08)
      : alpha(theme.palette.common.black, 0.04),
  },

  '&.Mui-selected': {
    color: inverted ? theme.palette.common.white : theme.palette.primary.main,
    backgroundColor: inverted ? theme.palette.grey[400] : alpha(theme.palette.primary.main, 0.08),
    '&:hover': {
      backgroundColor: inverted ? theme.palette.grey[500] : alpha(theme.palette.primary.main, 0.12),
    },
  },

  '&.Mui-disabled': {
    color: inverted
      ? alpha(theme.palette.common.white, 0.25)
      : alpha(theme.palette.common.black, 0.26),
    borderColor: inverted
      ? alpha(theme.palette.common.white, 0.25)
      : alpha(theme.palette.common.black, 0.12),
    border: inverted ? undefined : 0,
  },

  ...(inverted
    ? {}
    : {
        '&.MuiButtonGroup-grouped': {
          border: 0,
          borderRadius: '50%',
          margin: 0,
          '&:not(:first-of-type)': {
            borderTopLeftRadius: '50%',
            borderBottomLeftRadius: '50%',
            borderLeft: 0,
            marginLeft: 0,
          },
          '&:not(:last-of-type)': {
            borderTopRightRadius: '50%',
            borderBottomRightRadius: '50%',
          },
        },
      }),
}))
